import { siteAPIURL } from "./constants";
import type { EmailResult, EmailValidationResponse } from "@/app/api/validate-email/route";
import type { PhoneResult, PhoneValidationResponse } from "@/app/api/validate-phone/route";

export const experianValidateContact = async (
	type: "email" | "phone",
	value: string,
): Promise<boolean> => {
	const formattedValue = value.replaceAll(" ", "");

	try {
		const experian = (await fetch(
			siteAPIURL +
				(type === "email"
					? `/validate-email?email=${formattedValue}`
					: `/validate-phone?number=${formattedValue}`),
		).then(res => res.json())) as EmailValidationResponse | PhoneValidationResponse;

		const checkValidation = (experian: EmailValidationResponse | PhoneValidationResponse) => {
			// Check phone validation
			if (type === "phone") {
				const phoneResult = experian as PhoneValidationResponse;

				const phoneType = phoneResult?.result?.phone_type;
				const confidence = phoneResult?.result?.confidence;
				const isPhoneValid =
					confidence === "Verified" || (phoneType === "Landline" && confidence === "No coverage");
				return isPhoneValid;
			}

			// Check email validation
			if (type === "email") {
				const emailResult = experian as EmailValidationResponse;

				const isEmailValid =
					emailResult?.result?.verdict === "Valid" || emailResult?.result?.verdict === "Risky";
				return isEmailValid;
			} else {
				return false;
			}
		};

		return checkValidation(experian);
	} catch (err) {
		const error = err as Error;
		console.log(type === "email" ? "Email Validation Error" : "Phone Validation Error", error);
		return false;
	}
};
